import type { Money as MoneyObject } from "../graphql/types";

export interface MoneyProps {
  children: MoneyObject;
}

export function Money({ children }: MoneyProps) {
  return <>{toLocaleCurrency(children)}</>;
}

const formatters = new Map<string, Intl.NumberFormat>();

function getFormatter(currency: string) {
  const existingFormatter = formatters.get(currency);

  if (existingFormatter) {
    return existingFormatter;
  }

  const newFormatter = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
  });

  formatters.set(currency, newFormatter);

  return newFormatter;
}

function toLocaleCurrency(value: MoneyObject): string {
  const num = Number(value.amount) / 10 ** value.precision;

  if (toLocaleStringSupportsOptions()) {
    return getFormatter(value.currency).format(num);
  }

  return `${num} ${value.currency}`;
}

function toLocaleStringSupportsOptions() {
  return !!(
    typeof Intl === "object" &&
    Intl &&
    typeof Intl.NumberFormat === "function"
  );
}
